import { NgModule } from '@angular/core';
import { ActionMenuItemComponent } from './components/action-menu/action-menu-item/action-menu-item.component';
import { ActionMenuComponent } from './components/action-menu/action-menu.component';
import { ColumnToggleComponent } from './components/column-toggle/column-toggle.component';
import { DeleteDialogComponent } from './components/delete-dialog/delete-dialog.component';
import { DeviceSearchComponent } from './components/device-search/device-search.component';
import { DialogLoadingComponent } from './components/dialog-loading/dialog-loading.component';
import { ErrorComponent } from './components/error/error.component';
import { FilterControlComponent } from './components/filter-control/filter-control.component';
import { FirmwareSearchComponent } from './components/firmware-search/firmware-search.component';
import { LoadingComponent } from './components/loading/loading.component';
import { NoDataComponent } from './components/no-data/no-data.component';
import { TableContainerComponent } from './components/table-container/table-container.component';
import { TableControlsComponent } from './components/table-controls/table-controls.component';
import { TenantManagerComponent } from './components/tenant-manager/tenant-manager.component';
import { DropFileDirective } from './directives/drop-file.directive';
import { TableConfigDirective } from './directives/table-config.directive';
import { ExternalModule } from './external.module';
import { CheckPermissionPipe } from './pipes/check-permission.pipe';
import { FormatFileSizePipe } from './pipes/format-file-size.pipe';
import { GetM2MGateUrlPipe } from './pipes/get-m2mgate-url.pipe';
import { GetTenantNameByPathPipe } from './pipes/get-tenant-name-by-path.pipe';
import { GetTenantNamePipe } from './pipes/get-tenant-name.pipe';
import { IsBeforePipe } from './pipes/is-before.pipe';
import { MarkAsUTCPipe } from './pipes/mark-as-utc.pipe';
import { Im2mChipsComponent, Im2mDatePickerComponent, Im2mInputComponent, Im2mSelectionComponent } from '@m2mgate/sage-ui';

@NgModule({
    declarations: [
        ErrorComponent,
        TableControlsComponent,
        FilterControlComponent,
        DeleteDialogComponent,
        TenantManagerComponent,
        GetTenantNamePipe,
        IsBeforePipe,
        NoDataComponent,
        LoadingComponent,
        DropFileDirective,
        ActionMenuComponent,
        ColumnToggleComponent,
        TableConfigDirective,
        FormatFileSizePipe,
        CheckPermissionPipe,
        MarkAsUTCPipe,
        ActionMenuItemComponent,
        FirmwareSearchComponent,
        TableContainerComponent,
        DeviceSearchComponent,
        DialogLoadingComponent,
        GetTenantNameByPathPipe,
        GetM2MGateUrlPipe,
    ],
    imports: [
        ExternalModule,
        // m2mgate-sage-ui
        Im2mInputComponent,
        Im2mSelectionComponent,
        Im2mDatePickerComponent,
        Im2mChipsComponent,
    ],
    exports: [
        ErrorComponent,
        ExternalModule,
        TableControlsComponent,
        FilterControlComponent,
        DeleteDialogComponent,
        TenantManagerComponent,
        GetTenantNamePipe,
        IsBeforePipe,
        NoDataComponent,
        LoadingComponent,
        DropFileDirective,
        ActionMenuComponent,
        ColumnToggleComponent,
        TableConfigDirective,
        FormatFileSizePipe,
        CheckPermissionPipe,
        MarkAsUTCPipe,
        ActionMenuItemComponent,
        FirmwareSearchComponent,
        TableContainerComponent,
        DeviceSearchComponent,
        DialogLoadingComponent,
        GetTenantNameByPathPipe,
        GetM2MGateUrlPipe,
        // m2mgate-sage-ui
        Im2mInputComponent,
        Im2mSelectionComponent,
        Im2mDatePickerComponent,
        Im2mChipsComponent,
    ],
    providers: [
        GetTenantNamePipe,
        IsBeforePipe,
        FormatFileSizePipe,
        CheckPermissionPipe,
        MarkAsUTCPipe,
        GetTenantNameByPathPipe,
        GetM2MGateUrlPipe,
    ],
})
export class SharedModule {}
